import React, { useRef, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { PieChart, Pie, Cell, ResponsiveContainer, Label, Tooltip } from 'recharts';
import CustomLabel from './customLabel';
import CustomTooltip from './customTooltip';
import { newLine, newText } from './utils';
const alias = new Date().getTime();

const AtresPieChart = ({
  data,
  data2,
  showLabel,
  showMajorityLine,
  innerData,
  seatTotal,
  dataKey = 'votesPercent',
  isSenate,
  unitLabel,
  unitAbrv
}) => {
  const svg = useRef(null);
  const uLabel = unitLabel || (isSenate ? 'senadores' : 'escaños');
  const uAbrv = unitAbrv || (isSenate ? 'sen.' : 'esc.');
  useEffect(() => {
    if (seatTotal) {
      setTimeout(() => {
        try {
          const selSvg = svg.current.container.getElementsByTagName('svg');
          const textSvg = svg.current.container.querySelector("._middleLine".concat(alias));
          const line2 = svg.current.container.querySelector("._mayoria".concat(alias));

          if (textSvg && line2) {
            textSvg.remove();
            line2.remove();
          }

          if (selSvg && selSvg[0] && showMajorityLine && (!textSvg || !textSvg.length) && (!line2 || !line2.length)) {
            selSvg[0].append(newLine(alias));
            selSvg[0].append(newText(Math.trunc(seatTotal / 2 + 1), alias));
          }
        } catch (error) {}
      }, 500);
    }
  }, [seatTotal, showMajorityLine]);

  if (data2) {
    return React.createElement(ResponsiveContainer, {
      className: "doubleChart",
      minHeight: "226px",
      height: "100%",
      ref: svg
    }, React.createElement(PieChart, null, React.createElement(Tooltip, {
      content: React.createElement(CustomTooltip, {
        unitName: uAbrv
      })
    }), React.createElement(Pie, {
      dataKey: dataKey,
      data: data.filter(current => current.seats >= 1),
      startAngle: 180,
      endAngle: 0,
      label: CustomLabel,
      innerRadius: 120,
      outerRadius: 170,
      isAnimationActive: false,
      offset: 0,
      cy: "90%"
    }, React.createElement("line", {
      x1: "0",
      y1: "0",
      x2: "200",
      y2: "200"
    }), data.filter(current => current.seats >= 1).map((entry, index) => React.createElement(Cell, {
      key: entry.partyAcronym,
      fill: entry.partyColor
    })), showLabel && React.createElement(Label, {
      value: "".concat(seatTotal, " ").concat(uLabel),
      position: "center"
    })), data2 && React.createElement(Pie, {
      dataKey: dataKey,
      data: data2.filter(current => current.seats >= 1),
      startAngle: 180,
      endAngle: 0,
      label: CustomLabel,
      innerRadius: 65,
      outerRadius: 115,
      isAnimationActive: false,
      offset: 0,
      cy: "90%"
    }, React.createElement("line", {
      x1: "0",
      y1: "0",
      x2: "200",
      y2: "200"
    }), data2.filter(current => current.seats >= 1).map((entry, index) => React.createElement(Cell, {
      key: entry.partyAcronym,
      fill: entry.partyColor
    })), showLabel && React.createElement(Label, {
      value: "".concat(seatTotal, " ").concat(uLabel),
      position: "center"
    })), React.createElement("text", {
      id: "svgText",
      class: "year year_current",
      x: "0%",
      y: "93%",
      "text-anchor": "left"
    }, "10N"), React.createElement("text", {
      id: "svgText",
      class: "year year_last",
      x: "16%",
      y: "93%",
      "text-anchor": "left"
    }, "28A")));
  } else {
    return React.createElement(ResponsiveContainer, {
      ref: svg,
      aspect: 1.3
    }, React.createElement(PieChart, null, React.createElement(Tooltip, {
      content: React.createElement(CustomTooltip, {
        unitName: uAbrv
      })
    }), React.createElement(Pie, {
      dataKey: dataKey,
      data: data,
      startAngle: 180,
      endAngle: 0,
      label: CustomLabel,
      innerRadius: '80%',
      outerRadius: '135%',
      isAnimationActive: false,
      offset: 0,
      cy: "90%"
    }, React.createElement("line", {
      x1: "0",
      y1: "0",
      x2: "200",
      y2: "200"
    }), data.map((entry, index) => React.createElement(Cell, {
      key: entry.partyAcronym,
      fill: entry.partyColor
    })), showLabel && React.createElement(Label, {
      value: "".concat(seatTotal, " ").concat(uLabel),
      position: "center"
    }))));
  }
};

AtresPieChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.number
  })),
  seatTotal: PropTypes.number,
  innerData: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.number
  })),
  innerDataSeatTotal: PropTypes.number,
  showLabel: PropTypes.bool
};
AtresPieChart.defaultProps = {
  showTable: false,
  innerDate: undefined,
  showLabel: true
};
export default AtresPieChart;